import React, { useState } from 'react';
import chatApi from '../../services/chatApi';
import './CreateChannelModal.css';

const MAX_PHOTO_SIZE_BYTES = 500 * 1024 * 1024;

const CreateChannelModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    avatar: null
  });
  const [avatarPreview, setAvatarPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > MAX_PHOTO_SIZE_BYTES) {
        setError('Размер файла не должен превышать 500 МБ');
        return;
      }
      
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64 = reader.result;
        setAvatarPreview(base64);
        setFormData({ ...formData, avatar: base64 });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      if (!formData.name.trim()) {
        setError('Название канала обязательно');
        setLoading(false);
        return;
      }

      const channel = await chatApi.createChannel({
        name: formData.name.trim(),
        description: formData.description.trim() || null,
        avatar: formData.avatar || null
      });

      if (onSuccess) {
        onSuccess(channel);
      }
      
      // Сброс формы
      setFormData({ name: '', description: '', avatar: null });
      setAvatarPreview(null);
      onClose();
    } catch (err) {
      setError(err.message || 'Ошибка при создании канала');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({ name: '', description: '', avatar: null });
    setAvatarPreview(null);
    setError(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Создать канал</h2>
          <button className="modal-close" onClick={handleClose}>×</button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Аватар канала</label>
            <div className="avatar-upload">
              <div className="avatar-preview">
                {avatarPreview ? (
                  <img src={avatarPreview} alt="Preview" />
                ) : (
                  <div className="avatar-placeholder">📢</div>
                )}
              </div>
              <label className="avatar-upload-button">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleAvatarChange}
                  style={{ display: 'none' }}
                />
                {avatarPreview ? 'Изменить' : 'Загрузить аватар'}
              </label>
              {avatarPreview && (
                <button
                  type="button"
                  className="remove-avatar-button"
                  onClick={() => {
                    setAvatarPreview(null);
                    setFormData({ ...formData, avatar: null });
                  }}
                >
                  Удалить
                </button>
              )}
            </div>
          </div>

          <div className="form-group">
            <label>Название канала *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Введите название канала"
              required
              maxLength={100}
            />
          </div>

          <div className="form-group">
            <label>Описание</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Введите описание канала (необязательно)"
              rows={4}
              maxLength={500}
            />
          </div>

          <div className="form-actions">
            <button type="button" onClick={handleClose} className="btn-cancel">
              Отмена
            </button>
            <button type="submit" disabled={loading} className="btn-submit">
              {loading ? 'Создание...' : 'Создать канал'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateChannelModal;
